import { BLOCKS } from './blocks.js';
export var EMPTY_DOCUMENT = {
  nodeType: BLOCKS.DOCUMENT,
  data: {},
  content: [{
    nodeType: BLOCKS.PARAGRAPH,
    data: {},
    content: [{
      nodeType: 'text',
      value: '',
      marks: [],
      data: {}
    }]
  }]
};